import { TreeManager } from './tree-core/tree-manager';
import { DropRequest, DropUIZone } from './tree-core/tree-ui-facade';

export const getDropTargetElement = (event: MouseEvent, excludeKey?: string) => {
  const elements = document.elementsFromPoint(event.pageX, event.pageY);
  // console.log(elements);
  const divElement = elements.find(
    (el) =>
      el.parentElement?.hasAttribute('node-key') &&
      (!excludeKey || el.parentElement?.getAttribute('node-key') !== excludeKey),
  );
  return divElement?.parentElement;
};

const isAncestorOf = <T>(tree: TreeManager<T>, ancestorKey: string, nodeKey: string) => {
  let currentKey: string | undefined = nodeKey;
  do {
    currentKey = tree.getNode(currentKey).parent;
    if (currentKey === ancestorKey) {
      return true;
    }
  } while (currentKey !== undefined);

  return false;
};

export const isZoneLegit = <T>(treeManager: TreeManager<T>, draggingKey: string, key: string) =>
  !isAncestorOf(treeManager, draggingKey, key);

export const calcDragZone = (event: MouseEvent, element: Element) => {
  const key = element.getAttribute('node-key') as string;

  const offsetTop = event.pageY - element.getBoundingClientRect().top;
  const offsetBottom = element.getBoundingClientRect().bottom - event.pageY;
  const mapOffset = (val: number): 'A' | 'B' | undefined => {
    return val < 8 ? 'A' : val < 16 ? 'B' : undefined;
  };
  const top = mapOffset(offsetTop);
  const bottom = mapOffset(offsetBottom);

  const dragZone: DropUIZone = {
    key,
    position: top ? 'top' : bottom ? 'bottom' : 'center',
    threshold: top ? top : bottom ? bottom : undefined,
  };
  return dragZone;
};

export const isZoneDifferent = (a: DropUIZone | undefined, b: DropUIZone) => {
  if (!a || a.key !== b.key || a.position !== b.position || a.threshold !== b.threshold) {
    return true;
  }
  return false;
};

export const buildDropRequest = <T>(
  treeManager: TreeManager<T>,
  draggingKey: string | undefined,
  dropZone: DropUIZone | undefined,
): DropRequest | undefined => {
  if (!draggingKey || !dropZone) {
    return undefined;
  }
  const dropNode = treeManager.getNode(dropZone.key);
  const node = treeManager.getNode(draggingKey);

  const parentId = dropZone.position === 'center' ? dropNode.key : dropNode.parent;
  const oldPosition = node.index;

  const getPosition = () => {
    if (dropZone.position === 'center') {
      return undefined;
    }

    let position = dropNode.index + (dropZone.position === 'bottom' ? 1 : 0);
    if (parentId === node.parent && oldPosition < position) {
      // adjust same level move
      position--;
    }
    return position;
  };

  const request = { id: draggingKey, parentId, position: getPosition() };

  if (request.parentId === node.parent && request.position === oldPosition) {
    return undefined;
  }
  return request;
};
